'use client';

import useSWR, { mutate } from 'swr';

const KEY = 'artifact-chat-panel-width';

export function useArtifactPanelWidth(): number | null {
  const { data } = useSWR<number | null>(KEY, null, { fallbackData: null });
  return data ?? null;
}

export function publishArtifactPanelWidth(width: number | null): void {
  mutate(KEY, width, false);
}
